import React from 'react'

import APIKeys from './apiKeys/APIKeys'

export default class API extends React.Component {

  render() {
    return (
      <div>
        <APIKeys />
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/settings/modules/API.js